import type { FaireProductEntity } from "../../entity_types/product";

export const toysmith_2: FaireProductEntity = {
  token: "toysmith-2",
  type: "product",
  name: "Toysmith 10-Piece Sand Bucket Set",
  brandName: "Toysmith",
  imageUrl:
    "https://cdn.faire.com/fastly/f91611cd6673dc05393d4a27ab0dd31ba5a176a84ec31a75bf6b3be5c5fba9e4.jpeg?bg-color=FFFFFF&canvas=720:720&dpr=1&fit=bounds&format=jpg&height=720&width=720",
  priceDollars: 12,
  msrpDollars: 24,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-toys"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
